/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import displayInstalledByName from 'app/equipmentInformation/action/installationReport/partials/displayInstalledByName'
import displayInstallationDate
  from 'app/equipmentInformation/action/installationReport/partials/displayInstallationDate'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import initAddress from 'app/_shared/action/address/init'

const initReportAddress = initAddress(
  { component: 'country' },
  { attribute: 'installationReport' },
)

/**
 * EquipmentInformation Installation Report Edit Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  initReportAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
  displayInstalledByName(module),
  displayInstallationDate(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
